import React, { useEffect, useState } from 'react';
import LayoutOut from "../../components/Layout/LayoutOut";

const CacheOut = () => {
    const [done, setDone] = useState(false);

    useEffect(() => {
        const clearEverything = async () => {
            try {
                console.log("🧹 Nettoyage des caches...");
                setTimeout(() => {
                }, 30000);

                // Service Workers
                if ('serviceWorker' in navigator) {
                    const registrations = await navigator.serviceWorker.getRegistrations();
                    for (const registration of registrations) {
                        await registration.unregister();
                        console.log("✅ Service Worker supprimé");
                    }
                }

                // CacheStorage API
                if ('caches' in window) {
                    const cacheNames = await caches.keys();
                    await Promise.all(cacheNames.map(name => caches.delete(name)));
                    console.log("✅ Caches supprimés");
                }

                // LocalStorage & SessionStorage
                localStorage.clear();
                sessionStorage.clear();
                console.log("✅ LocalStorage et SessionStorage vidés");

                // ✅ Fin du nettoyage
                setDone(true);

                // Redirection vers la page d'accueil après 3 secondes
                setTimeout(() => {
                    window.location.href = '/';
                }, 3000);
            } catch (error) {
                console.error("❌ Erreur lors du nettoyage :", error);
            }
        };

        clearEverything();
    }, []);

    return (
        <LayoutOut>
            <div style={{ padding: 20, color: '#fff' }}>
                <h2>Nettoyage en cours...</h2>
                {done && <p>✅ Tous les caches ont été vidés. Redirection vers la page d'accueil ...</p>}
                {!done && <p>Veuillez patienter, cela peut prendre quelques secondes...</p>}
            </div>
        </LayoutOut>
    );
};

export default CacheOut;
